export const locationLimitMax = 3000;
export const REJECTED = 'rejected';
export const NEW = 'new';
export const VALID = 'valid';
